import axios from 'axios';

import { getMicroservicesDomain } from '../utils';
import { getDefaultHeaders } from '../utils/http';

const baseURL = `${getMicroservicesDomain()}/admin`;

export const getIsIncidentActive = async () => {
    try {
        const {
            data: { isActive },
        } = await axios.get(`${baseURL}/admin/status/incident/critical`, {
            headers: await getDefaultHeaders(),
        });
        return isActive;
    } catch {
        return false;
    }
};

export const updateIncidentStatus = async isActive => {
    try {
        const {
            data: { status },
        } = await axios.put(
            `${baseURL}/status/incident/critical`,
            {
                isActive,
            },
            {
                headers: await getDefaultHeaders(),
            },
        );
        return status.isActive;
    } catch {
        throw new Error('Could not update status');
    }
};
